import { observer } from 'mobx-react-lite'
import { match } from '@/utils/pattern-match-util'
import { ServiceTypeEmptyState, ServiceTypeList, ServiceTypeListItem } from './'
import type { DashboardViewModel } from '@/features/dashboard/DashboardView/DashboardViewModel'

interface ServiceTypesContainerProps {
  vm: DashboardViewModel
}

/**
 * The ServiceTypesContainer
 */
export const ServiceTypesContainer = observer(
  ({ vm }: ServiceTypesContainerProps) => {
    if (vm.serviceSelectionVm.availableServiceTypes.length === 0) {
      return <ServiceTypeEmptyState />
    }

    const isDisabled = vm.serviceSelectionVm.isPending
    return (
      <ServiceTypeList>
        {vm.serviceSelectionVm.availableServiceTypes.map((type) => {
          const isPending =
            vm.serviceSelectionVm.selectedServiceType === type &&
            vm.serviceSelectionVm.createDraft.pending
          const start = () =>
            vm.callCenterEnabled
              ? vm.callCenterAssistanceVm.selectServiceType(type)
              : vm.serviceSelectionVm.selectServiceType(type)
          return match(type, {
            Tax: (
              <ServiceTypeListItem
                key={type}
                icon="docs"
                title="Tax filing"
                description="File your personal or business taxes with expert support."
                isDisabled={isDisabled}
                onStart={start}
                isPending={isPending}
                testId="service-types-tax-filing-item"
              />
            ),
            Consultation: (
              <ServiceTypeListItem
                key={type}
                icon="chat-bubbles"
                title="Advisory"
                description="Schedule a call and get your questions answered from a Pro."
                isDisabled={isDisabled}
                isPending={isPending}
                onStart={start}
                testId="service-types-consultation-item"
              />
            ),
            Bookkeeping: (
              <ServiceTypeListItem
                key={type}
                icon="buildings"
                title="Bookkeeping"
                description="Keep your finances organized and your books up-to-date."
                isDisabled={isDisabled}
                isPending={isPending}
                onStart={start}
                testId="service-types-bookkeeping-item"
              />
            ),
            Misc: (
              <ServiceTypeListItem
                key={type}
                icon="rocket"
                title="Other services"
                description="Explore additional services tailored to your needs."
                isDisabled={isDisabled}
                isPending={isPending}
                onStart={start}
                testId="service-types-misc-item"
              />
            ),
          })
        })}
      </ServiceTypeList>
    )
  },
)
